module.exports = __webpack_public_path__ + "img/+.b6ea009a.svg";